module.exports = __webpack_public_path__ + "img/6-1_08.359c5f32.jpg";